import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-row mr-auto" }
const _hoisted_3 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8" }
const _hoisted_4 = { class: "py-6" }
const _hoisted_5 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_6 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, shallowRef, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import DateSelector from "@/components/tools/DateSelector.vue";
import ActivityLogFilterDialog from "@/components/dialogs/ActivityLogFilterDialog.vue";
import UserActivityLogsDetailDialog from "@/components/dialogs/UserActivityLogsDetailDialog.vue";
import router from "@/router";
import { translate } from "@/utils/tools";
import Toast from "@/components/tools/Toast.vue";
import { fal } from "@fortawesome/pro-light-svg-icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityLogs',
  setup(__props) {

dayjs.extend(localizedFormat);
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const detailDialogModal = ref<boolean>(false);
const selectedRow = ref({});
const toastConfig = ref({
  show: false,
  message: "",
  success: false,
  warning:false
});
const columns = [
  {
    label: translate("messages.activityLog.createdAt"),
    field: "createdAt",
    align: "left",
    format: (data: any) => dayjs(data.createdAt).locale("th").format("YYYY-MM-DDTHH:mm"),
  },
  {
    label: translate("messages.activityLog.action"),
    field: "action",
    align: "left",
  },
  {
    label: translate("messages.activityLog.amount"),
    field: "amount",
    align: "left",
    format: (data: any) => !data.amount ? '' :
      Number(data.amount / 100).toLocaleString("en", {
        useGrouping: true,
        minimumFractionDigits: 2,
      }),
  },
  {
    label: translate("messages.activityLog.actionBy"),
    field: "actorUsername",
    align: "left",
  },
  {
    label: translate("messages.activityLog.ipAddress"),
    field: "actorIp",
    align: "left",
    format: (data: any) => !data.actorIp ? '' :
      data.actorIp.split(",")[0].length > 16 ?
        data.actorIp.split(",")[0].substring(0, 16) : data.actorIp.split(",")[0],
  },
  {
    label: translate("messages.activityLog.actionTo"),
    field: "affectedName",
    class: () => "cursor-pointer hover:underline",
    isFunction: true,
    function: (data: any) =>
      data.affectedId ? router.push(`/players/${data.affectedId}`) : null,
  },
  {
    label: translate("messages.activityLog.logId"),
    field: "id",
    align: "left",

  },
  {
    // label: translate("messages.activityLog.copy"),
    field: "",
    sort: false,
    isIconFunction:true,
    isIconCopy: true,
    function: (data: any) => copyData(data),
  },
  {
    field: "",
    sort: false,
    isButton: true,
    isRow: true,
    clickable: true,
  },
];
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
});
const filterForm = ref({
  from: null,
  to: null,
  actionTo: null,
  action: null,
  actionBy: null,
  logId: null,
  ipAddress: null,
  amountGte: null,
  amountLte: null,
  traceId: null,
});

const filterModal = (flag = 0) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (flag == 1) {
    pageConfig.value.page = 1;
    fetchPageData();
  }
};
const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage } = pageConfig.value;
  const {
    from,
    to,
    actionTo,
    action,
    actionBy,
    logId,
    ipAddress,
    amountGte,
    amountLte,
    traceId,
  } = filterForm.value;
  const payload = {
    operatorId: store.state.selectedOperator.operatorId,
    page: page - 1,
    limit: rowsPerPage,
    offset: page * rowsPerPage - rowsPerPage,
    sortBy: [["createdAt", -1]],
    from: from || null,
    to: to || null,
    affectedName: actionTo || null,
    action: action || null,
    actorUsername: actionBy || null,
    id: logId || null,
    actorIp: ipAddress || null,
    amountGte: amountGte || null,
    amountLte: amountLte || null,
    traceId: traceId || null,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/user-activity-logs/list-v2`;
  const data = await axios
    .post(url, payload)
    .then(({ data }) => data.result);

  // if(!data || data.length == 0){
  //   if(pageConfig.value.page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  pageConfig.value.dataLength = data.length;

  dataRows.value = data;
  pageConfig.value = {
    ...pageConfig.value
  };
  selectedRow.value = {}
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `activity-logs?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};

const showDetailDialog = async (data: any) => {
  detailDialogModal.value = true;
  selectedRow.value = data;
}

const jsonPrettify = (json: any) => {
  if (typeof json === 'object' && json !== null) {
    const pretty = JSON.stringify(json, undefined, 4);
    return pretty;
  }

  try {
    const obj = JSON.parse(json);
    return jsonPrettify(obj);
  } catch (e) {
    return json;
  }
};

const copyData = (data: any) => {
  const tableData = jsonPrettify(data);

  navigator.clipboard.writeText(tableData)
    .then(() => {
      // console.log('Data copied to clipboard!');
      // alert('copied!!');
      toastConfig.value = {
        message: "copied to clipboard",
        show: true,
        success: true,
      };
    })
    .catch(err => {
      // console.error('Failed to copy text: ', err);
      toastConfig.value = {
        message: "copied to clipboard fail",
        show: true,
        success: false,
      }
    });
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.activityLog.activityLogs')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DateSelector, { onSearch: onSearch })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (filterModal())),
            class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
          }, [
            _createVNode(_component_font_awesome_icon, {
              class: "text-white mr-2",
              icon: ['far', 'filter'],
              transform: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.activityLog.advanceFilter")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(DataTable, {
              columns: columns,
              data: dataRows.value,
              onShowDetailTable: showDetailDialog,
              isLoaded: isLoaded.value
            }, null, 8, ["data", "isLoaded"]),
            _createVNode(Pagination, {
              config: pageConfig.value,
              "onUpdate:config": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig).value = $event))
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"]),
    _createVNode(ActivityLogFilterDialog, {
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[4] || (_cache[4] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"]),
    _createVNode(UserActivityLogsDetailDialog, {
      show: detailDialogModal.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((detailDialogModal).value = $event)),
      form: selectedRow.value,
      onClosed: _cache[6] || (_cache[6] = ($event: any) => (fetchPageData()))
    }, null, 8, ["show", "form"])
  ], 64))
}
}

})